import { Component, OnInit } from '@angular/core';
import { PopulationQuery, TransactionType } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-activity-page',
  templateUrl: './activity-page.component.html',
  styleUrls: ['./activity-page.component.scss'],
})
export class ActivityPageComponent implements OnInit {
  screenType = ScreenType;
  transactionTypes = TransactionType;
  populations = Populations;
  isSuiteOrPts: boolean = false;

  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit() {
    this.isSuiteOrPts = this.populationQuery.userInPopulation([this.populations.Suite, this.populations.Pts]);
  }
}
